// import React from "react";
// import ImageUploader from "react-images-upload";

// export const MultipleImageUploadComponent = ({
//   title,
//   smallTitle,
//   onDrop,
//   imageExtension,
// }) => {
//   return (
//     <React.Fragment>
//       <div className="file_upload mt-3">
//         <div className="file-lable-text">
//           <label>{title}</label>
//           <p>{smallTitle}</p>
//         </div>
//         <ImageUploader
//           withLabel={false}
//           withIcon={false}
//           withPreview={true}
//           buttonText={<i className="fa fa-plus" style={{ color: "#fff" }}></i>}
//           onChange={onDrop}
//           imgExtension={imageExtension}
//           maxFileSize={5242880}
//         />
//       </div>
//     </React.Fragment>
//   );
// };
// export default MultipleImageUploadComponent;

import React from "react";
import { Image } from "react-bootstrap";
import { SRLWrapper } from "simple-react-lightbox";
import ProgressBar from "react-bootstrap/ProgressBar";
import CloseIcon from "@material-ui/icons/Close";
import Slider from "react-slick";
import { ImageCropMultiple } from "./ImageCrop/ImageCrop";
import PdfDisplay from "./PdfDisplay";
import AlertDialogProgress from "../../reusableComponents/allPopupReusable/DialogProgression";

export const MultipleImageUploadComponent = ({
  title,
  smallTitle,
  onChange,
  stateValue,
  removeImage,
  checkCondition,
  accept,
  loader,
  singleUpload,
  videoUpload,
  newUploaded,
  onCompleteUploadMultipleCrop,
  combined,
  disabled,
  cancelFiles,
  thumbnail,
  progress,
  extraClass,
}) => {
  // console.log(newUploaded);
  const options = {
    settings: {
      autoplaySpeed: 3000,
      disableKeyboardControls: false,
      disablePanzoom: false,
      disableWheelControls: false,
      hideControlsAfter: 3000,
      lightboxTransitionSpeed: 0.6,
      lightboxTransitionTimingFunction: "linear",
      overlayColor: "rgba(0, 0, 0, 0.9)",
      slideAnimationType: "fade",
      slideSpringValues: [300, 200],
      slideTransitionSpeed: 0.6,
      slideTransitionTimingFunction: "linear",
    },
    buttons: {
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: false,
      showNextButton: false,
      showPrevButton: false,
      showThumbnailsButton: false,
    },
    caption: {
      showCaption: false,
    },
    thumbnails: {
      showThumbnails: false,
    },
    progressBar: {
      showProgressBar: false,
    },
  };
  //slider settings
  const settings = {
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  // const filename = (e) => {
  //  const split1 = e?.split("/");
  //  const nameArr=split1[split1?.length - 1]?.split("-");
  //  const name = nameArr[nameArr?.length - 1]?.replace(/[^a-zA-Z ]/g, " ");
  //   return(
  //        name
  //   )
  // }
  const filename = (e) => {
    const split1 = e?.split("/") ?? [];
    const nameArr = split1[split1?.length - 1]?.split("-") ?? [];
    const name =
      nameArr[nameArr?.length - 1]?.replace(/[^a-zA-Z ]/g, " ") ?? "";
    return name;
  };

  return (
    <React.Fragment>
      <div className="file_upload mt-3 mb-3">
        <div className="file-lable-text pr-5">
          <div className="f16-500">{title}</div>
          <div className="f11-400 opacity5 mb-3 mt-1">{smallTitle}</div>
        </div>
        <div className={`d-flex flex-wrap align-items-center ${extraClass}`}>
          {checkCondition === false ? null : (
            <>
              {videoUpload && stateValue?.length ? null : (
                <div className="enUploadBox">
                  <Image
                    src={require("../../../assets/images/UserManagement/uploadImg.svg")}
                    alt="uploadImg"
                    title="uploadImg"
                    fluid
                  />
                  <input
                    type="file"
                    onChange={onChange}
                    accept={accept}
                    value=""
                    // change true = false
                    multiple={singleUpload ? false : true}
                    disabled={disabled}
                    title=""
                  />
                </div>
              )}
            </>
          )}
          <Slider
            {...settings}
            className={`sliderUploadImges ${videoUpload && `video-upload`}`}
            // style={videoUpload && { width: "226px" }}
          >
            {(stateValue || []).map((url, index) => (
              <>
                <div
                  className="enIconUploaded"
                  key={index}
                  style={{ marginTop: "3.5rem", width: "100%" }}
                >
                  {checkCondition === false ? null : (
                    <button
                      type="button"
                      style={{ zIndex: "9" }}
                      className="remove-button-css remove-button-css-align"
                      onClick={() => {
                        removeImage(index);
                      }}
                    >
                      <CloseIcon
                        style={{
                          color: "#fff",
                          background: "#f85032",
                          fontSize: 18,
                          borderRadius: 50,
                          padding: 1,
                        }}
                      />
                    </button>
                  )}
                  {videoUpload && url !== "" && (
                    <video width="100%" height="100%" controls>
                      <source src={url} />
                      Your browser does not support the video tag.
                    </video>
                  )}
                  {/* orignal */}
                  {/* {videoUpload && url !== "" && (
                    <video width="100%" height="100%" controls>
                      <source src={url}type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )} */}
                  {!videoUpload && url !== "" && (
                    <SRLWrapper options={options}>
                      {url.substr(url.length - 3) === "pdf" ? (
                        <PdfDisplay src={url} />
                      ) : (
                        // <PdfDisplay src={url} />
                        <Image
                          src={url}
                          alt="Document"
                          style={{ maxHeight: "110px" }}
                          className="rounded img-thumbnail"
                          fluid
                          onClick={(e) => {
                            // window.print(url);
                          }}
                        />
                      )}
                    </SRLWrapper>
                  )}
                </div>
                <p
                  className="mx-2"
                  style={{ fontSize: "10px", textAlign: "center" }}
                >
                  {" "}
                  {filename(url)}
                </p>
              </>
            ))}
          </Slider>
          {newUploaded &&
            newUploaded.length > 0 &&
            newUploaded.map((file, index) => {
              return (
                <React.Fragment>
                  <ImageCropMultiple
                    src={file}
                    key={index}
                    combined={combined && combined}
                    onCompleteUploadMultipleCrop={onCompleteUploadMultipleCrop}
                    onCancelCrop={(file) => {
                      cancelFiles(file);
                    }}
                    thumbnail={thumbnail}
                  />
                </React.Fragment>
              );
            })}
        </div>
        {/* <div className="view_chainsBor restaurant_details_onboarding_file_upload">
          {checkCondition === false ? null : (
            <div className="custom_file_upload restaurant_details_onboarding_custom_file_upload">
              <input
                type="file"
                className="custom_input_upload"
                style={{ zIndex: 1 }}
                onChange={onChange}
                accept={accept}
                multiple
              />
              <label className="custom_input_label newChain_add" htmlFor="file">
                <div>
                  <i className="fa fa-plus" style={{ color: "#CCCCCC" }}></i>
                </div>
                <div className="add_new_text"></div>
              </label>
            </div>
          )}
          <div className="newChain_addthree m-0">
            {(stateValue || []).map((url, index) => (
              <div className="position-relative" key={index}>
                <div>
                  <SRLWrapper options={options}>
                    <Image src={url} className="newChain_addtwo" alt="Photos" />
                  </SRLWrapper>
                  {checkCondition === false ? null : (
                    <div
                      className="remove-button-css remove-button-css-two-image-upload"
                      onClick={removeImage(index)}
                    >
                      <Image
                        src={require("../../../assets/images/Icon/remove.png")}
                        fluid
                        className="remove-button-image"
                      />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div> */}
        {loader ? (
          <ProgressBar animated variant="success" label="Uplaoding" now={100} />
        ) : null}
        {/* {!progress && progress === 0 ? null : (
                    <AlertDialogProgress
                      progress={progress}
                      title="Video Uploading..."
                    />
                  )} */}
      </div>
    </React.Fragment>
  );
};

export default MultipleImageUploadComponent;

export const MultipleImageUploadShowComponent = ({ imgSrc }) => {
  const options = {
    settings: {
      autoplaySpeed: 3000,
      disableKeyboardControls: false,
      disablePanzoom: false,
      disableWheelControls: false,
      hideControlsAfter: 3000,
      lightboxTransitionSpeed: 0.6,
      lightboxTransitionTimingFunction: "linear",
      overlayColor: "rgba(0, 0, 0, 0.9)",
      slideAnimationType: "fade",
      slideSpringValues: [300, 200],
      slideTransitionSpeed: 0.6,
      slideTransitionTimingFunction: "linear",
    },
    buttons: {
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: false,
      showNextButton: false,
      showPrevButton: false,
      showThumbnailsButton: false,
    },
    caption: {
      showCaption: false,
    },
    thumbnails: {
      showThumbnails: false,
    },
    progressBar: {
      showProgressBar: false,
    },
  };
  return (
    <React.Fragment>
      <SRLWrapper>
        {/* <a href="../../../assets/images/UserManagement/items.png"> */}
        {imgSrc.map((item, index) => (
          <a href={item} key={index}>
            <Image
              //src={require("../../../assets/images/UserManagement/items.png")}
              src={item}
              alt="Photos"
              className="mb-1 mr-1"
              width="20px"
              height="20px"
            />
          </a>
        ))}
      </SRLWrapper>
    </React.Fragment>
  );
};
